import { LoginView, NoPermissions } from '../pages';

export const routesAuth = [
  {
    path: '/auth/login',
    element: <LoginView />,
  },
  {
    path: '/auth/forbidden',
    element: <NoPermissions />,
  },
];
